var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2499 37.2143C34.9019 33.8338 32.2854 32.1063 29.4152 30.7173C30.1862 29.7365 31.007 28.8304 31.6736 27.8247C34.5288 23.5332 34.0463 17.5092 30.6737 13.596C26.0626 8.24907 17.855 8.10967 13.1991 12.7447C9.26938 16.6628 8.18995 22.3583 11.0203 27.307C13.4677 31.5835 17.2332 33.6397 22.1926 33.4654C23.8241 33.4107 25.4706 33.321 27.0972 33.4405C29.8032 33.6347 32.7331 36.2982 33.2952 38.9269C33.335 39.126 33.2056 39.4845 33.0415 39.5841C29.5545 41.7547 25.7542 42.9645 21.6454 42.9993C11.5625 43.079 2.75306 35.9796 0.514635 26.0623C-2.10184 14.4424 5.52871 2.75773 17.268 0.417814C28.3657 -1.79266 39.2892 4.97318 42.219 15.8563C43.9302 22.2139 42.7762 28.1035 39.2792 33.565C38.4635 34.8395 37.3393 35.9198 36.2499 37.2143Z",
    fill: "#FEFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeader);
export default __webpack_public_path__ + "static/media/logo-header.15ae203696e886fa2aaff67daa131302.svg";
export { ForwardRef as ReactComponent };